/* import __COLOCATED_TEMPLATE__ from './banner.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  heading: string;
  description: string;
  imageUrl?: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const Banner = templateOnlyComponent<Signature>();
export default Banner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::Banner': typeof Banner;
    'standalone/common/banner': typeof Banner;
  }
}
